import views from '@/views/';

export default [
  {
    component: views.feeDispense.saleDrug,
    label: '直接售药',
    path: 'saledrug',
    name: 'saleDrug',
  },
  {
    component: views.feeDispense.waitFee,
    label: '待收费',
    path: 'waitfee',
    name: 'waitFee',
  },
  {
    component: views.feeDispense.waitFeeDetail,
    label: '待收费详情',
    path: 'waitFeedetail',
    name: 'waitFeeDetail',
    menuHidden: true,
  },
  {
    component: views.feeDispense.feeList,
    label: '已收费',
    path: 'feelist',
    name: 'feelist',
    meta: {
      keepAlive: true,
    },
  },
  {
    component: views.feeDispense.feeDetail,
    label: '已收费详情',
    path: 'feedetail',
    name: 'feeDetail',
    menuHidden: true,
  },
  {
    component: views.feeDispense.returdFee,
    label: '已退费',
    path: 'returdfee',
    name: 'returdFee',
    meta: {
      keepAlive: true,
    },
  },
  {
    component: views.feeDispense.returd,
    label: '退费',
    path: 'returd',
    name: 'returd',
    menuHidden: true,
  },
  {
    component: views.feeDispense.returdDetail,
    label: '已退费详情',
    path: 'returddetail',
    name: 'returdDetail',
    menuHidden: true,
  },
  {
    component: views.feeDispense.financeToday,
    label: '当日财务',
    path: 'financeToday',
    name: 'financeToday',
  },
  {
    component: views.feeDispense.arrears,
    label: '欠费管理',
    path: 'arrears',
    name: 'arrears',
    meta: {
      // keepAlive: true,
    },
  },
  {
    component: views.feeDispense.arrearsDetail,
    label: '欠费管理详情',
    path: 'arrearsdetail',
    name: 'arrearsDetail',
    menuHidden: true,
  },
];
